/**
 * Индикатор шагов wizard (First screen / Model pick, Figma).
 */

import checkIcon from "../../assets/wizard-step-check.svg";

export type WizardProgressStepId =
  | "industry"
  | "models"
  | "status"
  | "params"
  | "result";

const STEPS: ReadonlyArray<{ id: WizardProgressStepId; label: string }> = [
  { id: "industry", label: "Отрасль" },
  { id: "models", label: "Модель" },
  { id: "status", label: "Опыт" },
  { id: "params", label: "Параметры" },
  { id: "result", label: "Результат" },
];

type WizardProgressProps = {
  current: WizardProgressStepId;
};

export function WizardProgress({ current }: WizardProgressProps) {
  const currentIndex = STEPS.findIndex((step) => step.id === current);

  return (
    <ol className="wizard-progress" aria-label="Шаги подбора">
      {STEPS.map((step, index) => {
        const state =
          index < currentIndex ? "done" : index === currentIndex ? "current" : "upcoming";
        return (
          <li key={step.id} className={`wizard-progress__item wizard-progress__item--${state}`}>
            <span className="wizard-progress__index" aria-hidden="true">
              {state === "done" ? (
                <img
                  className="wizard-progress__check"
                  src={checkIcon}
                  alt=""
                  width={12}
                  height={9}
                />
              ) : (
                index + 1
              )}
            </span>
            <span className="wizard-progress__label">{step.label}</span>
          </li>
        );
      })}
    </ol>
  );
}

/** Сводит внутренний шаг Wizard к 5-шаговой шкале UI. */
export function toProgressStep(step: string): WizardProgressStepId {
  switch (step) {
    case "industry":
      return "industry";
    case "models":
      return "models";
    case "status":
    case "tour":
      return "status";
    case "params":
      return "params";
    case "result":
    case "next":
      return "result";
    default:
      return "industry";
  }
}
